import { URI_REPORT } from '@/config/config'

export default async ({ rootState }, { query }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const client = rootState['DATA-ACCESS'].client;
  const userToken = rootState['DATA-ACCESS'].userToken;
  query.clientId = client._id;
  
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken,
    },
    body: JSON.stringify(query)
  }

  const employeeNotificationInfoResult = await fetch(`${URI_REPORT}reports/employee-notifications/${query.employeeId}?startDate=${query.startDate}&endDate=${query.endDate}`, opts)
  const jsonResult = await employeeNotificationInfoResult.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult
}